import { HashRouter, Navigate, Route, Routes } from 'react-router-dom'

import { AnalysisPage } from '../pages/analysis'
import { AnalyticsPage } from '../pages/analytics'
import { AutomationPage } from '../pages/automation'
import { CreatePage } from '../pages/create'
import { MonitorPage } from '../pages/monitor'
import { TaskDetailPage } from '../pages/task-detail'
import { CreativesPage } from '../pages/creatives'
import { OverviewPage } from '../pages/overview'
import { PartnershipPage } from '../pages/partnership'
import { RenewalPage } from '../pages/renewal'
import { AppShell } from './AppShell'
import { KitPage } from './KitPage'

export function AppRouter() {
  return (
    <HashRouter>
      <Routes>
        {import.meta.env.DEV ? <Route path="/__kit" element={<KitPage />} /> : null}
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/monitor" replace />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/monitor" element={<MonitorPage />} />
          <Route path="/monitor/:campaignId" element={<TaskDetailPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/creatives" element={<CreativesPage />} />
          <Route path="/analysis" element={<AnalysisPage />} />
          <Route path="/automation" element={<AutomationPage />} />
          <Route path="/partnership" element={<PartnershipPage />} />
          <Route path="/renewal" element={<RenewalPage />} />
          <Route path="*" element={<Navigate to="/monitor" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  )
}
